import { useState, useEffect, useContext } from 'react'
import ContextStates from '../context/ContextStates';
import { FaEye, FaPen, FaTrash } from "react-icons/fa";
import axios from 'axios'
import { Url } from './Url';


const ListPedidos = (props) => {
    const [pedidos, setPedidos] = useState([])
    const { modify, setPedidoSelected, setFormView, setViewOpen, roles, idUsuario } = useContext(ContextStates)

    useEffect(() => {
        const consultaPedidos = async () => {
            const formData = new FormData()
            formData.append("estado", props.estado)
            try {
                const response = await axios({
                    url: Url + 'api/listadopedidos.php',
                    method: 'POST',
                    data: formData,
                })
                setPedidos(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaPedidos()
    }, [modify])


    const handleView = (item, action) => {
        //console.log(item)
        setPedidoSelected(item)
        setFormView(action)
        setViewOpen(true)
    }


    return (
        <div className="w-full py-5 md:px20 rounded-2xl">
            <table className='w-full'>
                <thead>
                    <tr className='p-1 bg-blue-400 text-white'>
                        <th className='px-2'>Número</th>
                        <th className='px-2'>Fecha</th>
                        <th className='px-2'>Hora</th>
                        <th className='px-2'>Hora de entrega</th>
                        <th className='px-2'>Cliente</th>
                        <th className='px-2'>Domicilio</th>
                        <th className='px-2'>Comanda</th>
                        <th className='px-2'>Estado</th>
                        <th className='px-2'>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {pedidos && (
                        pedidos.map((item, index) => (
                            <>
                                {((roles.includes("1") || roles.includes("41")) || (parseInt(item.estado) === 4 && roles.includes("42") && item.idu === idUsuario)) && (
                                    <tr key={index} className={`border border-gray-300 p-2 hover:cursor-pointer ${item.stockmin > item.stock ? 'bg-red-100' : index % 2 === 0 ? 'bg-white hover:bg-slate-200' : 'bg-slate-100 hover:bg-slate-200'}`}>
                                        <td className='text-center' onClick={() => handleView(item, 120)}>{item.numero}</td>
                                        <td className='text-center' onClick={() => handleView(item, 120)}>{item.fecha}</td>
                                        <td className='text-center' onClick={() => handleView(item, 120)}>{item.hora}</td>
                                        <td className='text-center' onClick={() => handleView(item, 120)}>{item.horaespecifica}</td>
                                        <td className='text-center' onClick={() => handleView(item, 120)}>{item.cliente}</td>
                                        <td className='text-center' onClick={() => handleView(item, 120)}>{item.domicilio}</td>
                                        <td className='text-center' onClick={() => handleView(item, 120)}>{item.comanda}</td>
                                        <td onClick={() => handleView(item, 120)} className={`text-center ${item.estado === '1' ? 'bg-orange-400 text-white' : item.estado === '2' ? 'bg-yellow-400 text-black' : item.estado === '3' ? 'bg-green-400 text-gray-600' : item.estado === '4' && 'bg-cyan-400 text-gray-800'}`}>{item.estadopedido}</td>
                                        <td className='text-center'>
                                            <button className='bg-red-500 ml-2 hover:bg-red-400 rounded p-2 text-white' onClick={() => handleView(item, 121)}><FaTrash /></button>
                                        </td>
                                    </tr>
                                )}
                            </>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default ListPedidos